// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__12HFD","noInteraction":"EventWrapper_noInteraction__3yhBc"};